module.exports = __webpack_public_path__ + "img/gift-03-c1.510dca88.png";